import React, { useState, useEffect, useRef } from 'react';

export default function Loading() {
    const countUp = useRef(); // DOM を参照するための ref
    const countUpWrap = useRef(); // DOM を参照するための ref
    const [count, setCount] = useState(0); // カウントアップの状態

    useEffect(() => {
        const duration = 2000; // 2秒間
        const steps = 100; // カウントアップのステップ数
        const interval = duration / steps; // 各ステップの間隔

        let currentCount = 0;
        const timer = setInterval(() => {
            currentCount += 1;
            setCount(currentCount); // 状態を更新
            if (currentCount >= steps) {
                clearInterval(timer); // カウントアップ終了s


                setTimeout(() => {
                    countUpWrap.current.style.transform = 'translateY(-50px)'; // 単位を追加
                }, 500);
            }
        }, interval);

        return () => clearInterval(timer); // クリーンアップ
    }, []);

    useEffect(() => {
        if (countUp.current) {
            countUp.current.textContent = count; // DOM を直接更新
        }
    }, [count]);

    return (
        <div id="loadingWrap">
            <div >
                <p ref={countUpWrap}>
                    <span ref={countUp}>0</span>%
                </p>
            </div>
        </div>
    );
}
